import styled from "styled-components";

const DeliveryHistoryTimelineStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px 16px;
    background: white;
    border-radius: 8px;
    width: 100%;

    .statusInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .plusIconWrapper {
        cursor: pointer;
        display: flex;
        align-items: center;
        width: 14px;
        height: 14px;
    }

 
`

export { DeliveryHistoryTimelineStyled };
